import type { PropsWithChildren, FC } from 'react';
import { createContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { getTheme } from './defaultTheme';
import { useInjection } from 'inversify-react';
import { TYPES } from '@/engine/ioc';
import type { ThemeStore } from './Theme.store';
import { observer } from 'mobx-react';

export const ColorModeContext = createContext(() => {});

export const CustomThemeProvider: FC<PropsWithChildren> = observer(({ children }) => {
  const store = useInjection<ThemeStore>(TYPES.ThemeStore);

  const toggleColorMode = (): void => {
    store.setTheme(store.theme === 'light' ? 'dark' : 'light');
  };

  const theme = getTheme(store.theme);

  return (
    <ColorModeContext.Provider value={toggleColorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
});
